import { IconButton } from '@lokalise/louis';
import type { PropsWithChildren } from 'react';

import splitFileName from '../../../utils/splitFileName';
import StyleGuideInlineValueEditor from '../../StyleGuideInlineValueEditor';
import { IconPlaceholder, StyleGuideGridAnimatedRow, StyleGuideGridRowWrapper } from '../styles';
import TrashCanIcon from './TrashCanIcon';

type StyleGuideGridRowProps = {
    name: string;

    hidden?: boolean;
    readonly?: boolean;
    deletable?: boolean;
    removing?: boolean;

    onNameChanged?: (newName: string, currentName: string) => void;
    onDelete?: () => void;
};

const StyleGuideGridRow = ({
    children,
    deletable,
    onDelete,
    name,
    onNameChanged,
    hidden,
    readonly,
    removing,
}: PropsWithChildren<StyleGuideGridRowProps>) => {
    const { name: nameWithoutExtension, extension } = splitFileName(name);

    return (
        <StyleGuideGridAnimatedRow hidden={hidden === true}>
            <StyleGuideGridRowWrapper>
                {deletable ? (
                    <IconButton ariaLabel="Delete style guide" onClick={onDelete} loading={removing}>
                        <TrashCanIcon />
                    </IconButton>
                ) : (
                    <IconPlaceholder />
                )}

                <StyleGuideInlineValueEditor
                    required
                    areaLabel="Edit style guide name"
                    placeholder="Style guide name"
                    readonly={readonly}
                    value={nameWithoutExtension}
                    onEditSubmitted={(newValue) => onNameChanged?.(`${newValue}.${extension}`, name)}
                    responseHandler={() => Promise.resolve()}
                />

                {children}
            </StyleGuideGridRowWrapper>
        </StyleGuideGridAnimatedRow>
    );
};

export default StyleGuideGridRow;
